/**
 * Option Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.optionFormatter = function(value, row) {
    switch (value) {
        case 0:
            return '<span class="text-danger">'+__('No')+'</span>';
        case 1:
            return '<span class="test-success">'+__('Yes')+'</span>';
        case 2:
            return '<span class="text-muted">'+__('N/A')+'</span>';
    }
};
